export default __webpack_public_path__ + "static/career-lady-d542854930aa05b574f42d323b959b5e.png";